define('responsive-gameday/controllers/ScoringPlaysViewController',['require','exports','module','Responsive/controllers/ScrollViewController','message-service/message-service','../views/distributors/events/DistributionEvents','../views/Monitor/Events/ViewModelUpdateEvents','responsive-gameday-tracking/responsive-gameday-tracking','./LinescoreViewController','Responsive/util/renderComplete','Responsive/util/array','GameDayCore/GDUtil/resources/GDConfig','extant/extant','../views/render/ScoringPlaysViewRender'],function(require,exports,module) {
    // Add private variables here
    var ScrollViewController = require("Responsive/controllers/ScrollViewController"),
        MessageService = require("message-service/message-service"),
        DistEvents = require("../views/distributors/events/DistributionEvents"),
        VMEvents = require("../views/Monitor/Events/ViewModelUpdateEvents"),
        Tracking = require("responsive-gameday-tracking/responsive-gameday-tracking"),
        LinescoreViewController = require("./LinescoreViewController"),
        renderComplete = require("Responsive/util/renderComplete"),
        array = require("Responsive/util/array"),
        GDConfig = require("GameDayCore/GDUtil/resources/GDConfig"),
        exists = require("extant/extant"),
        ScoringPlaysViewRender = require( '../views/render/ScoringPlaysViewRender' );

    var Superclass,
        templates,
        mainRender;

    // Add private methods here
    // Constructor
    function ScoringPlaysViewController() {
        Superclass.constructor.call(this);
        this.referenceName = "scoringplays";
        this.autoSelectTab = true;
        this.activeClassName = "active";
        this.viewRender = new ScoringPlaysViewRender();

        MessageService.publish("registerViewComponent", this);
    }

    // Prototype Inheritence
    ScrollViewController.spawn(ScoringPlaysViewController).define({
        loadView: function () {
            var that = this;

            Superclass.loadView.call(this);
            this.setClassName("ScoringPlaysViewController");
        },

        viewWillAppear: function () {
            var that = this;
            Superclass.viewWillAppear.call(this);
            this.viewRender.setPitchToggler(this);

            this.onBeat = this.onBeat || function (payload) {
                that.drawScores(payload);
            };
            this.showOverlay();

        },

        viewDidAppear : function(){
            Superclass.viewDidAppear.call(this);
            MessageService.addListener.call(this, VMEvents.UPDATE_SCORES, this.onBeat);
            MessageService.publish(VMEvents.REQUEST_SCORES_DATA);
        },

        drawScores: function (payload) {
            var that = this;

            if (!this.isViewLoaded()) {
                return;
            }

            that.viewRender.viewState.version = {
                target: GDConfig.build.target,
                number: GDConfig.build.number
            };

            that.childWrapper.innerHTML = that.viewRender.render(payload);

            renderComplete(function () {
                that.hideOverlay();
                that.setScroll();
            });
        },

        viewWillDisappear: function () {
            if (this.onBeat) {
                MessageService.removeListener.call(this,VMEvents.UPDATE_SCORES, this.onBeat);
            }

            Superclass.viewWillDisappear.call(this);
        }
    });

    Superclass = ScoringPlaysViewController.superclass;
    return ScoringPlaysViewController;
});
